import api from "api";
import { supportApiBase } from "api/constants";
import { useQuery } from "react-query";
import { isUsMarket } from "utils/market";
import { queryKeys } from "utils/misc";
import { TemplateListItemDto } from "./templateDtos";
import { rolloutRefetchInterval } from "./catalogueDeployments";

export const useGetTemplates = (includeDeleted = false) =>
  useQuery<TemplateListItemDto[]>(
    [...queryKeys.templates(), { includeDeleted }],
    async () => {
      const locale = isUsMarket ? "en-US" : "sv-SE";
      const deleted = includeDeleted ? "&include_deleted=true" : "";
      // @ts-ignore — v2 endpoint, not in OpenAPI types
      const data = await api.parse(`GET /treatments/schedules?locale=${locale}${deleted}`, {
        root: supportApiBase,
      });
      return Array.isArray(data) ? data : [];
    },
    { refetchInterval: data => rolloutRefetchInterval(data) }
  );
